export default __webpack_public_path__ + "static/media/mccann-logo-black.800229f8.svg";